import { useState } from "react";
export const useAdvPagination = (initialLimit = 25, onPageChange) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);

  const handleLimitChange = (value) => {
    const newLimit = Number(value);
    const currentStartIndex = (page - 1) * limit + 1;
    const newPage = Math.ceil(currentStartIndex / newLimit);
    setLimit(newLimit);
    setPage(newPage);

    if (onPageChange) {
      onPageChange(newPage, newLimit);
    }
  };
  return {
    page,
    limit,
    setPage,
    setLimit,
    handleLimitChange,
  };
};
